import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { clearIndividualDeliveryChannelFormState } from '../store/slices/delivery-channels-form';
import {
  useLazyGetCorporateDeliveryChannelQuery,
  useCreateCorporateDeliveryChannelMutation,
  useUpdateCorporateDeliveryChannelMutation,
  useLazyGetCorporateDeliveryChannelsQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import DeliveryChannelForm from '../../partial/delivery-channels/form';

const CorpotateDeliveryChannelForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    corporateClientsRisk: {
      deliveryChannels: {
        form: { item },
      },
    },
  } = useAppSelector((state) => state);

  const { channelId } = useParams();
  const dispatch = useAppDispatch();

  const [getCorporateDeliveryChannel, { isLoading, isFetching }] =
    useLazyGetCorporateDeliveryChannelQuery();
  const [createDeliveryChannel, { isLoading: requestInProgress, isSuccess }] =
    useCreateCorporateDeliveryChannelMutation();
  const [
    updateDeliveryChannel,
    { isLoading: updateInProgress, isSuccess: updateSuccess },
  ] = useUpdateCorporateDeliveryChannelMutation();

  const [getList] = useLazyGetCorporateDeliveryChannelsQuery();

  const getCorporateDeliveryChannelAction = useCallback(() => {
    getCorporateDeliveryChannel(channelId as string);
  }, [channelId]);

  useEffect(() => {
    setPanelIsOpen(true);

    if (channelId) {
      getCorporateDeliveryChannelAction();
    }

    return () => {
      dispatch(clearIndividualDeliveryChannelFormState());
    };
  }, [dispatch, channelId, getCorporateDeliveryChannelAction]);

  return (
    <DeliveryChannelForm
      clientType={RiskScoreClientTypeEnum.CORPORATE}
      getList={getList}
      item={item}
      updateDeliveryChannel={updateDeliveryChannel}
      createDeliveryChannel={createDeliveryChannel}
      isSuccess={isSuccess}
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      isLoading={isLoading || isFetching}
      requestInProgress={requestInProgress}
      updateInProgress={updateInProgress}
      updateSuccess={updateSuccess}
    />
  );
};

export default CorpotateDeliveryChannelForm;
